import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class MultiChannelIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16"><path d="M5.946 6.857a.332.332 0 0 1-.321-.295V2.286l3.938 2.138L13.5 2.286v4.276a.331.331 0 0 1-.321.295zM13.5 1.276L9.562 3.429 5.626 1.196V.319A.343.343 0 0 1 5.947 0h7.233a.345.345 0 0 1 .321.319v.957zm4.03 9.758c.235 0 .392.08.47.473v4.099a.371.371 0 0 1-.391.394H9.39a.371.371 0 0 1-.39-.394v-4.099a.371.371 0 0 1 .391-.394h1.096v2.601h.783V9.143h2.973v1.26h-1.878v.631zM7.132 8a.809.809 0 0 1 .743.762v3.048a.754.754 0 0 1-.743.761H6.91l-.446 2.286-1.708-2.286H.743A.754.754 0 0 1 0 11.81V8.762A.754.754 0 0 1 .743 8h6.389z"/></svg>
        )
    }
}

export default withCssClassName(MultiChannelIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/multi-channel-icon.js